import { z } from 'zod';
import { genderValues } from './gender';
import { ChronicIllnessSchema } from './chronicIllnesses';

export const PATIENT_DATA_FIELDS = {
  BIRTHDATE: 'birthdate',
  GENDER: 'gender',
  CHRONIC_ILLNESSES: 'chronicIllnesses',
} as const;

export type PatientDataFieldName =
  (typeof PATIENT_DATA_FIELDS)[keyof typeof PATIENT_DATA_FIELDS];

export { type Gender } from './gender';

export const PatientDataSchema = z.object({
  birthdate: z
    .string()
    .date()
    .refine((date) => new Date(date) <= new Date(), {
      message: 'Birthdate cannot be in the future',
    }),
  gender: z.enum(genderValues),
  chronicIllnesses: z.array(ChronicIllnessSchema),
});

export type PatientData = z.infer<typeof PatientDataSchema>;

export const GetPatientDataResponseSchema = z.object({
  patientData: PatientDataSchema.nullable(),
});
export type GetPatientDataResponseDTO = z.infer<
  typeof GetPatientDataResponseSchema
>;
